// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.observation-form {
	width: 100%;

	.form-control-sm {
		border-width: thin;
	}
	.date-time-input {
		max-width: 9rem;
		input {
			width: 100%;
		}
	}
	.species-selector {
		max-width: 9rem;
	}
	.number-input {
		/* Chrome, Safari, Edge, Opera */
		input::-webkit-outer-spin-button,
		input::-webkit-inner-spin-button {
			-webkit-appearance: none;
			margin: 0;
		}

		/* Firefox */
		input[type="number"] {
			-moz-appearance: textfield;
		}

		max-width: 2rem;
		input {
			width: 100%;
		}
	}
	.text-input {
		max-width: 6rem;
		input {
			width: 100%;
		}
	}
	.button-column {
		width: 5rem;
		max-width: 5rem;
		button {
			width: 100%;
			font-size: 0.8rem;
		}
	}
}

.highlight {
	background-color: darkgrey;
	td {
		background-color: transparent !important;
	}
}

.uncertain {
	background-color: orange;
	td {
		background-color: transparent !important;
	}
}
`, "",{"version":3,"sources":["webpack://./src/styles/observationform.css"],"names":[],"mappings":"AAAA;CACC,WAAW;;CAEX;EACC,kBAAkB;CACnB;CACA;EACC,eAAe;EACf;GACC,WAAW;EACZ;CACD;CACA;EACC,eAAe;CAChB;CACA;EACC,gCAAgC;EAChC;;GAEC,wBAAwB;GACxB,SAAS;EACV;;EAEA,YAAY;EACZ;GACC,0BAA0B;EAC3B;;EAEA,eAAe;EACf;GACC,WAAW;EACZ;CACD;CACA;EACC,eAAe;EACf;GACC,WAAW;EACZ;CACD;CACA;EACC,WAAW;EACX,eAAe;EACf;GACC,WAAW;GACX,iBAAiB;EAClB;CACD;AACD;;AAEA;CACC,0BAA0B;CAC1B;EACC,wCAAwC;CACzC;AACD;;AAEA;CACC,wBAAwB;CACxB;EACC,wCAAwC;CACzC;AACD","sourcesContent":[".observation-form {\n\twidth: 100%;\n\n\t.form-control-sm {\n\t\tborder-width: thin;\n\t}\n\t.date-time-input {\n\t\tmax-width: 9rem;\n\t\tinput {\n\t\t\twidth: 100%;\n\t\t}\n\t}\n\t.species-selector {\n\t\tmax-width: 9rem;\n\t}\n\t.number-input {\n\t\t/* Chrome, Safari, Edge, Opera */\n\t\tinput::-webkit-outer-spin-button,\n\t\tinput::-webkit-inner-spin-button {\n\t\t\t-webkit-appearance: none;\n\t\t\tmargin: 0;\n\t\t}\n\n\t\t/* Firefox */\n\t\tinput[type=\"number\"] {\n\t\t\t-moz-appearance: textfield;\n\t\t}\n\n\t\tmax-width: 2rem;\n\t\tinput {\n\t\t\twidth: 100%;\n\t\t}\n\t}\n\t.text-input {\n\t\tmax-width: 6rem;\n\t\tinput {\n\t\t\twidth: 100%;\n\t\t}\n\t}\n\t.button-column {\n\t\twidth: 5rem;\n\t\tmax-width: 5rem;\n\t\tbutton {\n\t\t\twidth: 100%;\n\t\t\tfont-size: 0.8rem;\n\t\t}\n\t}\n}\n\n.highlight {\n\tbackground-color: darkgrey;\n\ttd {\n\t\tbackground-color: transparent !important;\n\t}\n}\n\n.uncertain {\n\tbackground-color: orange;\n\ttd {\n\t\tbackground-color: transparent !important;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
